import {DatePipe} from '@angular/common';
import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {CycleLogActionType, CycleStatusData, CycleStatusType, ICycle} from '@core/api/data-access';
import {TranslateModule} from '@ngx-translate/core';
import {IconComponent} from '@shared/icon';

@Component({
	selector: 'dc-cycle-result-item', // Standard prefix 'dc'
	imports: [TranslateModule, DatePipe, IconComponent],
	templateUrl: './cycle-result-item.component.html', // Separate template
	styleUrls: ['./cycle-result-item.component.scss', '../result-item.shared.scss'], // Separate styles
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CycleResultItemComponent {
	// --- Inputs ---
	readonly item = input.required<ICycle>(); // Define the required 'item' input
	protected readonly getCycleStatusData = CycleStatusData.getStatusData;
	protected readonly CycleStatusType = CycleStatusType;

	protected readonly creationDate$ = computed(() => {
		const log = this.item()?.log;
		return log && log.find(l => l.action === CycleLogActionType.CycleCreated)?.timestamp;
	});

	// --- Lifecycle Hooks ---
	// ngOnInit(): void {}

	// --- Constructor ---
	constructor() {}
}
